import { ApexApiError } from 'apex-ui-services'
import { AxiosResponse } from 'axios'
import { Dispatch } from 'redux'
import { getCorrespondent as getCorrespondentApi } from '../api'
import { HttpResponseStatusCodes } from '../constants'
import {
  CORRESPONDENT_RETRIEVAL_FAILED,
  TEMPORARILY_UNAVAILABLE,
} from './constants'

export const GET_CORRESPONDENT = 'GET_CORRESPONDENT'
export const GET_CORRESPONDENT_SUCCESS = 'GET_CORRESPONDENT_SUCCESS'
export const GET_CORRESPONDENT_FAILURE = 'GET_CORRESPONDENT_FAILURE'

export const getCorrespondent = (
  dispatch: Dispatch,
  accountNumber: string,
  onError: (error: string) => void
) => {
  dispatch({ type: GET_CORRESPONDENT, accountNumber })
  getCorrespondentApi(accountNumber)
    .then((response: AxiosResponse) => {
      const {
        data: [{ code, name }],
      } = response
      dispatch({
        type: GET_CORRESPONDENT_SUCCESS,
        correspondent: { code, name },
      })
    })
    .catch((error: ApexApiError) => {
      const httpResponseStatus = error.response?.status
      const errorMessage =
        httpResponseStatus &&
        httpResponseStatus >= HttpResponseStatusCodes.InternalServerError
          ? TEMPORARILY_UNAVAILABLE
          : CORRESPONDENT_RETRIEVAL_FAILED
      dispatch({ type: GET_CORRESPONDENT_FAILURE })
      onError(errorMessage)
    })
}
